import {
  invoicesResponseSchema, type InvoicesResponse, type InvoiceStatus 
} from '../types';
import {
  ApiClientError, buildUrl 
} from '@/errors';
import {
  authFetch, API_BASE_URL 
} from '@/lib/api-client';

export interface InvoiceFilters {
  readonly status?: InvoiceStatus;
  readonly supplierId?: string;
}

export async function getInvoices(filters?: InvoiceFilters): Promise<InvoicesResponse> {
  const params = new URLSearchParams();
  if (filters?.status) params.set('status', filters.status);
  if (filters?.supplierId) params.set('supplierId', filters.supplierId);

  const url = buildUrl(API_BASE_URL, '/v1/invoices', params);
  const response = await authFetch(url);
  
  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to fetch invoices');
  }

  return invoicesResponseSchema.parse(await response.json());
}
